// @flow

/**
 * Animation durations.
 */

const duration = {
  fast: '.25s',
  regular: '.5s'
};

/**
 * Timing functions.
 */

const timingFunction = {
  easeOutQuart: 'cubic-bezier(0.8, 0, 0.2, 1)',
  easeQuad: 'cubic-bezier(0.57, 0.61, 0, 1)',
  regular: 'cubic-bezier(.52, .01, .16, 1)'
};

/**
 * Export `Default` transition.
 */

export const defaultTransition = `${duration.regular} ${timingFunction.regular}`;

/**
 * Export `Navicon` transition.
 */

export const naviconTransition = {
  fast: '300ms cubic-bezier(.23, 1, .32, 1)',
  slow: '300ms 300ms cubic-bezier(.23, 1, .32, 1)'
};

/**
 * Export `Animations` constants.
 */

export const animations = {
  duration,
  timingFunction
};



// WEBPACK FOOTER //
// ../src/client/styles/animations.js